// angular
import {Component, input} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
// types
import {IReminder} from "@app/shared/types/reminder.type";
// utils
import {convertIsoToJalaali} from "@app/shared/utils/convert-iso-to-jalaali";

@Component({
  selector: "app-notification-item",
  templateUrl: "./notification-item.component.html",
  styleUrls: ["./notification-item.component.scss"],
  standalone: true,
  imports: [TranslateModule],
})
export class NotificationItemComponent {
  public convertToJalaali = convertIsoToJalaali;

  // inputs
  readonly notificationData = input.required<IReminder>();
}
